/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type HelpCenterSettingsPhoneConfigurationAppEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line typescript/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

/*
This entrypoint is using JSResourceForInteraction instead of the preferred JSResourceForUserVisible.
This is because the phone configuration page utilises a binary download button, using a binary that is hosted within AFM.
This binary load mechanism is not compatible with SSR, so the package needs to be excluded from the SSR bundle.
*/
export const helpCenterSettingsPhoneConfigurationAppEntryPoint: EntryPoint<
	HelpCenterSettingsPhoneConfigurationAppEntryPointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction<HelpCenterSettingsPhoneConfigurationAppEntryPointComponent>(
		/* webpackChunkName: "async-help-center-settings-phone-configuration-app" */ './HelpCenterSettingPhoneConfigurationApp.tsx',
	),
	getPreloadProps: () => ({}),
});
